// Business-day arithmetic for delivery estimates. Weekends are skipped; statutory holidays
// are not known to the portal, so an estimate can land a day or two early around them.
export const addBusinessDays = (start, days) => {
  const date = new Date(start);
  let added = 0;
  while (added < days) {
    date.setDate(date.getDate() + 1);
    const weekday = date.getDay();
    if (weekday !== 0 && weekday !== 6) added += 1;
  }
  return date;
};

// The first and last expected delivery dates for a window of business days from start.
export const deliveryRange = (start, { min_business_days: min, max_business_days: max }) => ({
  from: addBusinessDays(start, min),
  to: addBusinessDays(start, max),
});
